// mobile.service.ts
import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { takeUntil, map, distinctUntilChanged } from 'rxjs/operators';

const CUSTOM_BREAKPOINT_992 = '(max-width: 992px)';
@Injectable({
  providedIn: 'root'
})
export class MobileService implements OnDestroy {
  isMobile$: Observable<boolean>;
  private destroy$ = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) {
    this.isMobile$ = this.breakpointObserver.observe([Breakpoints.Handset, CUSTOM_BREAKPOINT_992] )
      .pipe(
        takeUntil(this.destroy$),
        map(result => result.breakpoints[Breakpoints.Handset] || result.breakpoints[CUSTOM_BREAKPOINT_992]),
        distinctUntilChanged()
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}